module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro2-old.480cdac5.mp3";